import React from 'react'
import * as d3 from './d3.modified.js'

export default class BezierLink extends React.PureComponent {
    constructor(props) {
        super(props)
        this.props.linkItem._jsx = {
            styleSelect: this.styleSelect,
            styleDeselect: this.styleDeselect,
            styleSelectHandles: this.styleSelectHandles,
            styleDeselectHandles: this.styleDeselectHandles,
            styleFromNodeMove: this.styleFromNodeMove,
            styleToNodeMove: this.styleToNodeMove,
            styleFade: this.styleFade,
            dom: this
        }
    }

    static genLine(link) {
        const curvedLine = d3.line().curve(d3.curveBasis)
        var newPoints = []
        newPoints.push([link.x1, link.y1])
        newPoints.push([link.x1 + (link.x2-link.x1)*link.properties.w1x, link.y1 + (link.y2-link.y1)*link.properties.w1y])
        newPoints.push([link.x1 + (link.x2-link.x1)*link.properties.w2x, link.y1 + (link.y2-link.y1)*link.properties.w2y])
        newPoints.push([link.x2, link.y2])

        // for (let i=0; i<10; i++) {

        // }

        return curvedLine(newPoints)
    }

    componentDidUpdate() {
        this.styleFromNodeMove()
    }

    componentDidMount() {
        let link = this.props.linkItem

        link.refs.holder
            .transition()
                .duration(500)
                .style('opacity', 1)

        link.refs.mouseCatcher
            .on("click", ()=>{
                this.props.keyPressDict.link = false
                d3.event.stopPropagation()
                this.props.clickHandler(this.props.linkItem)
            })

        if (link.refs.w1) {
            link.refs.w1.call(d3.drag()
                .on('drag', ()=>{
                    this.props.linkItem.properties.w1x = (d3.event.x - this.props.linkItem.x1) / (this.props.linkItem.x2-this.props.linkItem.x1)
                    this.props.linkItem.properties.w1y = (d3.event.y - this.props.linkItem.y1) / (this.props.linkItem.y2-this.props.linkItem.y1)
                    this.props.updateLinkShape(this.props.linkItem)
                    this.styleFromNodeMove(/*true*/)
                })
                .on('end', ()=>{
                    this.props.updateLinksRemotely([link.id], {
                        w1x: this.props.linkItem.properties.w1x,
                        w1y: this.props.linkItem.properties.w1y,
                        w2x: this.props.linkItem.properties.w2x,
                        w2y: this.props.linkItem.properties.w2y,
                    })
                }))
            link.refs.w2.call(d3.drag().on('drag', ()=>{
                this.props.linkItem.properties.w2x = (d3.event.x - this.props.linkItem.x1) / (this.props.linkItem.x2-this.props.linkItem.x1)
                this.props.linkItem.properties.w2y = (d3.event.y - this.props.linkItem.y1) / (this.props.linkItem.y2-this.props.linkItem.y1)
                this.props.updateLinkShape(this.props.linkItem)
                this.styleFromNodeMove(/*true*/)
            })
            .on('end', ()=>{
                this.props.updateLinksRemotely([link.id], {
                    w1x: this.props.linkItem.properties.w1x,
                    w1y: this.props.linkItem.properties.w1y,
                    w2x: this.props.linkItem.properties.w2x,
                    w2y: this.props.linkItem.properties.w2y,
                })
            }))
        }

        this.styleFromNodeMove()
    }

    styleFade = () => {
        this.props.linkItem.refs.holder
            .transition()
                .duration(200)
                .style('opacity', 0)
    }

    styleFromNodeMove = (skipRecalc=false) => {
        let link = this.props.linkItem

        link.refs.w1.attr('cx', link.x1 + (link.x2-link.x1)*link.properties.w1x)
        link.refs.w1.attr('cy', link.y1 + (link.y2-link.y1)*link.properties.w1y)
        link.refs.w2.attr('cx', link.x1 + (link.x2-link.x1)*link.properties.w2x)
        link.refs.w2.attr('cy', link.y1 + (link.y2-link.y1)*link.properties.w2y)
        // let d = BezierLink.genLine(link)
        link.refs.line.attr('d', `
                    M ${link.x1} ${link.y1}
                    C ${link.x1 + (link.x2-link.x1)*link.properties.w1x} ${link.y1 + (link.y2-link.y1)*link.properties.w1y}, ${link.x1 + (link.x2-link.x1)*link.properties.w2x} ${link.y1 + (link.y2-link.y1)*link.properties.w2y}, ${link.x2} ${link.y2}
                `)
        link.refs.mouseCatcher.attr('d', `
                    M ${link.x1} ${link.y1}
                    C ${link.x1 + (link.x2-link.x1)*link.properties.w1x} ${link.y1 + (link.y2-link.y1)*link.properties.w1y}, ${link.x1 + (link.x2-link.x1)*link.properties.w2x} ${link.y1 + (link.y2-link.y1)*link.properties.w2y}, ${link.x2} ${link.y2}
                `)

        link.refs.handle1.attr('x1', link.x1)
        link.refs.handle1.attr('y1', link.y1)
        link.refs.handle1.attr('x2', link.x1 + (link.x2-link.x1)*link.properties.w1x)
        link.refs.handle1.attr('y2', link.y1 + (link.y2-link.y1)*link.properties.w1y)

        link.refs.handle2.attr('x1', link.x2)
        link.refs.handle2.attr('y1', link.y2)
        link.refs.handle2.attr('x2', link.x1 + (link.x2-link.x1)*link.properties.w2x)
        link.refs.handle2.attr('y2', link.y1 + (link.y2-link.y1)*link.properties.w2y)

        // link.refs.center.attr('cx', (link.x1 + link.x2 + 3.0*(2.0*link.x1 + (link.x2-link.x1)*(link.properties.w1x+link.properties.w2x) ))/8.0)
        // link.refs.center.attr('cy', (link.y1 + link.y2 + 3.0*(2.0*link.y1 + (link.y2-link.y1)*(link.properties.w1y+link.properties.w2y) ))/8.0)
        if (link.properties.linksymbol) {
            let cx = (link.x1 + link.x2 + 3.0*(2.0*link.x1 + (link.properties.w2x+link.properties.w1x)*(link.x2-link.x1)))/8.0
            let cy = (link.y1 + link.y2 + 3.0*(2.0*link.y1 + (link.properties.w2y+link.properties.w1y)*(link.y2-link.y1)))/8.0
            let angle = Math.atan2(
                            (link.properties.w2y-link.properties.w1y+1)*(link.y2-link.y1),
                            (link.properties.w2x-link.properties.w1x+1)*(link.x2-link.x1)
                        )* 180 / Math.PI + 90
            link.refs.center.attr( 'transform', `translate(${cx} ${cy}) rotate(${angle}) translate(0 -10)`)
        }
    }

    styleToNodeMove = () => {
        this.styleFromNodeMove()
    }

    styleSelect = () => {
        let link = this.props.linkItem
        // this._oldColor = link.refs.line.style('stroke')
        // link.refs.line.style('stroke', '#4285F4')
        this.props.enqueueClassChange({
            elem: link.refs.line,
            class: 'active',
            val: true,
        })
        if (!link.properties.linksymbol) {
            return
        }
        this.props.enqueueClassChange({
            elem: link.refs.center,
            class: 'active',
            val: true,
        })
    }

    styleDeselect = () => {
        let link = this.props.linkItem
        this.props.enqueueClassChange({
            elem: link.refs.line,
            class: 'active',
            val: false,
        })
        if (!link.properties.linksymbol) {
            return
        }
        this.props.enqueueClassChange({
            elem: link.refs.center,
            class: 'active',
            val: false,
        })
        // link.refs.line.style('stroke', this._oldColor!==link.properties.color?link.properties.color:this._oldColor)
    }

    styleSelectHandles = () => {
        let link = this.props.linkItem
        if (this.props.edit) {
            this.props.enqueueClassChange({
                elem: link.refs.w1,
                class: 'active',
                val: true,
            })
            this.props.enqueueClassChange({
                elem: link.refs.w2,
                class: 'active',
                val: true,
            })
            this.props.enqueueClassChange({
                elem: link.refs.handle1,
                class: 'active',
                val: true,
            })
            this.props.enqueueClassChange({
                elem: link.refs.handle2,
                class: 'active',
                val: true,
            })
        }
    }

    styleDeselectHandles = () => {
        let link = this.props.linkItem
        this.props.enqueueClassChange({
            elem: link.refs.w1,
            class: 'active',
            val: false,
        })
        this.props.enqueueClassChange({
            elem: link.refs.w2,
            class: 'active',
            val: false,
        })
        this.props.enqueueClassChange({
            elem: link.refs.handle1,
            class: 'active',
            val: false,
        })
        this.props.enqueueClassChange({
            elem: link.refs.handle2,
            class: 'active',
            val: false,
        })
    }

    render () {
        let link = this.props.linkItem
        link.refs = {}

        const diffColors = {
            none: "#cacaca",
            yellow: 'yellow',   //"#FFFFE6",
            green: 'green',     //"#E6FFED",
            red: 'red',         //"#FFEEF0"
        }
        let cx = (link.x1 + link.x2 + 3.0*(2.0*link.x1 + (link.properties.w2x+link.properties.w1x)*(link.x2-link.x1)))/8.0
        let cy = (link.y1 + link.y2 + 3.0*(2.0*link.y1 + (link.properties.w2y+link.properties.w1y)*(link.y2-link.y1)))/8.0
        let angle = Math.atan2(
                        (link.properties.w2y-link.properties.w1y+1)*(link.y2-link.y1),
                        (link.properties.w2x-link.properties.w1x+1)*(link.x2-link.x1)
                    )* 180 / Math.PI + 45 + 180

        let symbols = {
            "triangle": "M 0 3 L 4 17 L -4 17 Z",
            "triangle_reversed": "M 4 3 L 0 17 L -4 3 Z",
            "diamond": "M 0 0 L 4 10 L 0 20 L -4 10 Z",
        }

        return (
            <g ref={c=>link.refs.holder=d3.select(c)} opacity="0">
                <path
                    ref={c=>link.refs.mouseCatcher=d3.select(c)}
                    // d={BezierLink.genLine(link)}
                    d={`
                        M ${link.x1} ${link.y1}
                        C ${link.x1 + (link.x2-link.x1)*link.properties.w1x} ${link.y1 + (link.y2-link.y1)*link.properties.w1y}, ${link.x1 + (link.x2-link.x1)*link.properties.w2x} ${link.y1 + (link.y2-link.y1)*link.properties.w2y}, ${link.x2} ${link.y2}
                    `}
                    className="node-link-mouseCatcher"
                    id={`L_${link.id}`}
                />
                <path
                    ref={c=>link.refs.line=d3.select(c)}
                    // d={BezierLink.genLine(link)}
                    d={`
                        M ${link.x1} ${link.y1}
                        C ${link.x1 + (link.x2-link.x1)*link.properties.w1x} ${link.y1 + (link.y2-link.y1)*link.properties.w1y}, ${link.x1 + (link.x2-link.x1)*link.properties.w2x} ${link.y1 + (link.y2-link.y1)*link.properties.w2y}, ${link.x2} ${link.y2}
                    `}
                    className={`node-link ${link._compareType?'node-link-diff-'+link._compareType:''}`}
                    style={{
                        stroke: link._compareType?diffColors[link._compareType]:(link.properties.color==='hidden'?'transparent':link.properties.color),
                        strokeWidth: link.properties.width||1,
                    }}
                    // className={`node-link ${link._compareType?'node-link-diff-'+link._compareType:''}`}
                    // filter={'parent-child'===link.properties.type?'url(#doubleFilter)':'none'}
                    // filter='url(#doubleFilter)'
                    // shapeRendering="geometricPrecision"
                    // markerEnd="url(#kruzicic)"
                    // markerStart="url(#kruzicic)"
                    // markerMid="url(#kruzicic)"
                />
                <line
                    x1={link.x1}
                    y1={link.y1}
                    x2={link.x1 + (link.x2-link.x1)*link.properties.w1x}
                    y2={link.y1 + (link.y2-link.y1)*link.properties.w1y}
                    ref={c=>link.refs.handle1=d3.select(c)}
                    className="node-link-handles"
                />
                <line
                    x1={link.x2}
                    y1={link.y2}
                    x2={link.x1 + (link.x2-link.x1)*link.properties.w2x}
                    y2={link.y1 + (link.y2-link.y1)*link.properties.w2y}
                    ref={c=>link.refs.handle2=d3.select(c)}
                    className="node-link-handles"
                />
                <circle
                    cx={link.x1 + (link.x2-link.x1)*link.properties.w1x}
                    cy={link.y1 + (link.y2-link.y1)*link.properties.w1y}
                    r="5"
                    fill="#aaa"
                    ref={c=>link.refs.w1=d3.select(c)}
                    className="node-link-weights"
                />
                <circle
                    cx={link.x1 + (link.x2-link.x1)*link.properties.w2x}
                    cy={link.y1 + (link.y2-link.y1)*link.properties.w2y}
                    r="5"
                    fill="#aaa"
                    ref={c=>link.refs.w2=d3.select(c)}
                    className="node-link-weights"
                />
                {
                    (link.properties.linksymbol)
                        ? (
                            <path
                                d={symbols[link.properties.linksymbol]}
                                ref={c=>link.refs.center=d3.select(c)}
                                className="node-link-symbol"
                                transform={`translate(${cx} ${cy}) rotate(${angle}) translate(0 -10)`}
                                style={{
                                    stroke: link._compareType?diffColors[link._compareType]:link.properties.color,
                                    strokeWidth: link.properties.width||1,
                                    fill: link._compareType?diffColors[link._compareType]:link.properties.color,
                                }}
                            />
                        )
                        : null
                }

            </g>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/BezierLink.js